import { faThLarge } from '@fortawesome/pro-regular-svg-icons/faThLarge';
import React from 'react';
import useHasMounted from '../../../hooks/useHasMounted';
import { COLOR } from '../../../styles/colors';
import Icon from '../../../ui/Icon/Icon';
import useSiteNavContext from '../SiteNavContext';
import SiteNavDropdown from '../SiteNavDropdown';
import { getMediaData } from '../SiteNavUtils';
import { StyledSiteNavButton } from '../StyledSiteNav';
import MediaDropdownList from './MediaDropdownList';

const MediaDropdown = () => {
  const { setActiveNavId, clearActiveNavId, activeNavId, siteNavData } =
    useSiteNavContext();
  const hasMounted = useHasMounted();

  const mediaData = getMediaData(siteNavData);
  const isOpen = activeNavId === 'apps';

  return (
    <StyledSiteNavButton
      onMouseEnter={() => setActiveNavId('apps')}
      onMouseLeave={clearActiveNavId}
      as="div"
    >
      <Icon icon={faThLarge} color={COLOR.white} size={22} />
      {(isOpen || !hasMounted) && (
        <SiteNavDropdown direction="right">
          {mediaData.map(m => (
            <MediaDropdownList key={m.text} links={m.subItems} title={m.text} />
          ))}
        </SiteNavDropdown>
      )}
    </StyledSiteNavButton>
  );
};

export default MediaDropdown;
